module.exports = __webpack_public_path__ + "static/media/poap.a01bdf19.png";